import * as React from 'react';
import { cn } from '@/lib/utils';

export interface CDSectionHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Section letter (e.g., "A", "B", "C") */
  letter?: string;
  /** Section title text */
  title: string;
  /** Optional right-aligned content (e.g., amounts) */
  rightContent?: React.ReactNode;
}

/**
 * CDSectionHeader - Black bar section header
 *
 * Used for major sections like:
 * - "Loan Terms"
 * - "Projected Payments"
 * - "Costs at Closing"
 * - Closing Cost Details sections (A, B, C, etc.)
 *
 * Styling:
 * - Black background (#000000)
 * - White text
 * - 11pt bold Arial
 * - Full width
 */
export const CDSectionHeader = React.forwardRef<HTMLDivElement, CDSectionHeaderProps>(
  ({ letter, title, rightContent, className, ...props }, ref) => {
    return (
      <div ref={ref} className={cn('cd-section-header', className)} {...props}>
        <span>
          {letter && <span className="mr-2">{letter}.</span>}
          {title}
        </span>
        {rightContent && <span className="ml-auto">{rightContent}</span>}
      </div>
    );
  },
);

CDSectionHeader.displayName = 'CDSectionHeader';
